import { Alert, Badge, Button, Card, EmptyState, PageHeading } from '@aulaviva/ui';
import { Building2, CalendarClock, CircleHelp, CircleX, MonitorPlay, Radio, Wifi } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useWebinarRelatore } from '@/api/gestione';
import { formattaIntervallo } from '@/lib/date';
import { comuni, relatore as t } from '@/testi';

export function IMieiWebinar() {
  const webinar = useWebinarRelatore();
  const navigate = useNavigate();
  return (
    <>
      <PageHeading subtitle={t.sottotitolo}>{t.titolo}</PageHeading>
      {webinar.isPending && <p className="t-body text-ink-muted">{comuni.caricamento}</p>}
      {webinar.isError && <Alert variant="error" title={webinar.error.message} action={<Button onClick={() => webinar.refetch()}>{comuni.riprova}</Button>} />}
      {webinar.data?.length === 0 && (
        <EmptyState icon={CalendarClock} title={t.nessunoTitolo}>
          {t.nessunoTesto}
        </EmptyState>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {webinar.data?.map((w) => (
          <Card key={w.id} className="flex flex-col gap-4">
            <div className="flex flex-wrap justify-between gap-2">
              <p className="t-body-small text-ink-muted">{formattaIntervallo(w.inizioPrevisto, w.finePrevista)}</p>
              <Badge variant={w.stato === 'in_diretta' ? 'accent' : 'neutral'}>{t.stati[w.stato]}</Badge>
            </div>
            <div className="flex flex-col gap-1">
              <h2 className="t-title-3">{w.titolo}</h2>
              <p className="t-body-small text-ink-muted">{w.percorsoTitolo}</p>
            </div>
            <ul className="flex flex-wrap gap-2" aria-label={t.titolo}>
              <li>
                <Badge icon={Wifi} variant="success">
                  {t.confermatiOnline(w.conteggi.confermatiOnline)}
                </Badge>
              </li>
              <li>
                <Badge icon={Building2} variant="success">
                  {t.confermatiSala(w.conteggi.confermatiSala)}
                </Badge>
              </li>
              <li>
                <Badge icon={CircleHelp} variant="warning">
                  {t.invitati(w.conteggi.invitati)}
                </Badge>
              </li>
              <li>
                <Badge icon={CircleX} variant="neutral">
                  {t.rinunciati(w.conteggi.rinunciati)}
                </Badge>
              </li>
            </ul>
            {w.modalitaIngresso === 'relatore' ? (
              <Alert variant="info" title={t.modalitaRelatore} />
            ) : (
              <p className="t-body-small text-ink-muted inline-flex items-center gap-2">
                <Radio aria-hidden size={16} strokeWidth={1.75} />
                {t.modalitaRegia}
              </p>
            )}
            <Button icon={MonitorPlay} onClick={() => navigate(`/relatore/webinar/${w.id}`)} className="self-start">
              {t.apriConsole}
            </Button>
          </Card>
        ))}
      </div>
    </>
  );
}
